import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
}

export const LoadingContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${C.DARK_BLUE}
`

export const Root = styled.div`
  font-family: 'Roboto';
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`